import { LeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import {
  Alert, Button, Form as AntdForm, Input, Typography,
  Modal,
} from 'antd';
import { connect } from 'react-redux';
import {
  forgotPassword as forgotPasswordAction,
  forgotPasswordErrorClear as forgotPasswordErrorClearAction,
  ForgotPasswordResponse,
  ForgotPasswordAction,
} from '@triare/auth-redux/dist/saga/auth/forgotPassword';
import { Error } from '@triare/auth-redux/dist/saga/common';
import { Action } from '@triare/auth-redux';
import { validationSignInEmailAndPassword, createRulesForAntd } from '../../../../utils/validations';
import SendSuccess from './SendSuccess';
import { getMessageInError } from '../../../../hooks/fetch';
import Wrapper from '../Wrapper';
import Submit from '../../../Common/Form/Button/Submit';
import { RootState } from '../../../../store';
import { moduleName } from '../../../../store/auth';

import styles from './index.module.scss';
import { IconTipping } from '../../../Common/Icon';

const { Text, Paragraph } = Typography;
const validationRules = createRulesForAntd(validationSignInEmailAndPassword);

interface ForgotPasswordProps {
  loading: boolean;
  response: ForgotPasswordResponse | null;
  error: Error;
  forgotPassword: (payload: ForgotPasswordAction) => Action;
  forgotPasswordErrorClear: () => Action;
  onClose?: () => void;
  setSignInOpen?: () => void;
  isOpen?: boolean;
}

function ForgotPassword({
  forgotPassword, forgotPasswordErrorClear, onClose, setSignInOpen, loading, response, error, isOpen,
}: ForgotPasswordProps) {
  const [sendSuccess, setSendSuccess] = useState(false);

  const onFinish = ({ email }: { email: string }) => {
    forgotPassword({ email });
  };

  useEffect(() => {
    if (response) {
      setSendSuccess(true);
    }
  }, [response]);

  return (
    <Modal
      onCancel={onClose}
      open={isOpen}
      footer={null}
      destroyOnClose
    >
      <AntdForm className={styles.form} layout="vertical" onFinish={onFinish}>
        {sendSuccess ? (
          <SendSuccess onClose={onClose} />
        ) : (
          <>
            {/* <Text className={styles.text} strong>
              Forgot your password?
            </Text>
            <Paragraph className={styles.secondary} type="secondary">
              No worries, well send you instructions on how to reset it.
            </Paragraph> */}
            <div style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            }}
            >
              <IconTipping />
              <h4 style={{ marginTop: '15px' }}>Forgot your password?</h4>
              <span style={{ fontWeight: 300 }}>
                Please enter the email address associated with your account,
                and we&apos;ll send you a verification link to reset your password

              </span>
            </div>

            {error && (
              <AntdForm.Item>
                <Alert
                  type="error"
                  onClose={() => forgotPasswordErrorClear()}
                  message={getMessageInError(error)}
                  closable
                  showIcon
                />
              </AntdForm.Item>
            )}

            <AntdForm.Item name="email" label="Email *" className={styles.email} rules={[validationRules]}>
              <Input size="large" placeholder="Email" />
            </AntdForm.Item>

            <Submit
              loading={loading}
              size="large"
              block
            >
              Send password reset email
            </Submit>

            <AntdForm.Item>
              <Button
                type="link"
                size="large"
                block
                style={{
                  color: 'black', textDecoration: 'underline', fontSize: '17px', fontWeight: '700',
                }}
                onClick={() => {
                  onClose?.();
                  setSignInOpen?.();
                }}
              >
                Back to log in
              </Button>
            </AntdForm.Item>

            {/* for test */}
            {/* eslint-disable-next-line react/button-has-type */}
            {/* <button onClick={() => setSendSuccess(true)}>
              test button
              {' '}
              <br />
              {' '}
              see what happens after a successful request
            </button> */}
          </>
        )}
      </AntdForm>
    </Modal>

  );
}

export default connect((state: RootState) => ({
  loading: state[moduleName].forgotPassword.loading,
  response: state[moduleName].forgotPassword.response,
  error: state[moduleName].forgotPassword.error,
}), {
  forgotPassword: forgotPasswordAction,
  forgotPasswordErrorClear: forgotPasswordErrorClearAction,
})(ForgotPassword);
